import { render, staticRenderFns } from "./ModalEditarEmail.vue?vue&type=template&id=f532a44a"
import script from "./ModalEditarEmail.vue?vue&type=script&lang=ts"
export * from "./ModalEditarEmail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports